import { createStyles } from '@mantine/core';

export const useItemStyle = createStyles((theme) => ({
  cardStyle: {
    background: 'rgba(255, 255, 255, 0.74)',
    backdropFilter: 'blur(9px)',
    // borderRadius: theme.defaultRadius,
    boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.15)',
  },
  addressStyle: {
    gap: 4,
    fontSize: 11,
  },
  requestInput: {
    background: '#FFFFFF',
    borderRadius: '10px',
    input: {
      border: '1px solid #7E7E7E',
      fontSize: '12px',
      fontWeight: 450,
    },
    'input:: placeholder': {
      fontSize: '12px',
      fontWeight: 500,
    },
  },
}));

export const textSliderStyle = createStyles(() => ({
  main: {
    textAlign: 'center',
    marginTop: '30px',
  },
  flex_row: {
    justifyContent: 'center',
    display: 'flex',
  },
  groupStyle: {
    flexWrap: 'nowrap',
  },
  imageStyle: {
    cursor: 'pointer',
  },
}));

export const useFoodStyle = createStyles((theme) => ({
  cardStyle: {
    background: theme.colors.white,
    // padding: 10
  },
  categoryStyle: {
    position: 'relative',
    right: '7px',
  },
  badgeStyle: {
    textTransform: 'capitalize',
  },
}));

export const accordionStyle = createStyles((theme) => ({
  item: {
    transition: 'transform 150ms ease',
    '&[data-active]': {
      backgroundColor: 'transparent',
      borderRadius: theme.radius.md,
      zIndex: 1,
    },
  },
  label: {
    padding: 0,
  },
  chevron: {
    display: 'none',
  },
  content: {
    padding: '5px 0px 0px 3px',
  },
  control: {
    boxShadow: '0px 5px 10px rgba(0,0,0,0.15)',
    borderRadius: '20px',
  },
}));

export const useAddToCartRefactoredStyles = createStyles((theme) => ({
  genericGridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexShrink: 0,
    flexShrink: 0,
    WebkitFlexGrow: 0,
    flexGrow: 0,
    ':-ms-flex-negative': 0,
    ':-ms-flex-positive': 0,
    ':-webkit-box-flex': 0,
  },

  firstGridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexBasis: `${(1 / 12) * 100}%`,
    flexBasis: `${(1 / 12) * 100}%`,
    maxWidth: `${(1 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(1 / 12) * 100}%`,

    [theme.fn.smallerThan('sm')]: {
      padding: 0,
      margin: 0,
      WebkitFlexBasis: `${(3 / 12) * 100}%`,
      flexBasis: `${(3 / 12) * 100}%`,
      maxWidth: `${(3 / 12) * 100}%`,
      ':-ms-flex-preferred-size': `${(3 / 12) * 100}%`,
    },
  },

  secondGridCol: {
    WebkitFlexBasis: `${(9 / 12) * 100}%`,
    flexBasis: `${(9 / 12) * 100}%`,
    maxWidth: `${(9 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(9 / 12) * 100}%`,

    [theme.fn.smallerThan('sm')]: {
      padding: 4,
      margin: 0,
      WebkitFlexBasis: `${(6 / 12) * 100}%`,
      flexBasis: `${(6 / 12) * 100}%`,
      maxWidth: `${(6 / 12) * 100}%`,
      ':-ms-flex-preferred-size': `${(6 / 12) * 100}%`,
    },
  },

  thirdGridCol: {
    WebkitFlexBasis: `${(2 / 12) * 100}%`,
    flexBasis: `${(2 / 12) * 100}%`,
    maxWidth: `${(2 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(2 / 12) * 100}%`,

    [theme.fn.smallerThan('sm')]: {
      padding: 0,
      margin: 0,
      WebkitFlexBasis: `${(3 / 12) * 100}%`,
      flexBasis: `${(3 / 12) * 100}%`,
      maxWidth: `${(3 / 12) * 100}%`,
      ':-ms-flex-preferred-size': `${(3 / 12) * 100}%`,
    },
  },

  table: {
    userSelect: 'none',

    'th, td': {
      padding: '0px !important',
    },

    'th:nth-of-type(1)': {
      width: '5%',
    },

    'th:nth-of-type(2)': {
      width: '50%',

      [theme.fn.smallerThan('sm')]: {
        width: '20%',
      },
    },

    'th:nth-of-type(3)': {
      width: '15%',
    },

    'th:nth-of-type(4)': {
      width: '30%',
    },

    th: {
      fontSize: '14px !important',

      [theme.fn.smallerThan('sm')]: {
        fontSize: '12px !important',
      },
    },

    td: {
      fontSize: '15px !important',

      [theme.fn.smallerThan('sm')]: {
        fontSize: '11px !important',
      },
    },
  },

  extraFoodChangerGenericGridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexShrink: 0,
    flexShrink: 0,
    WebkitFlexGrow: 0,
    flexGrow: 0,
    ':-ms-flex-negative': 0,
    ':-ms-flex-positive': 0,
    ':-webkit-box-flex': 0,
  },

  extraFoodChangerFirstGridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexBasis: `${(2 / 12) * 100}%`,
    flexBasis: `${(2 / 12) * 100}%`,
    maxWidth: `${(2 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(2 / 12) * 100}%`,

    [theme.fn.smallerThan('sm')]: {
      padding: 0,
      margin: 0,
      WebkitFlexBasis: `${(2 / 12) * 100}%`,
      flexBasis: `${(2 / 12) * 100}%`,
      maxWidth: `${(2 / 12) * 100}%`,
      ':-ms-flex-preferred-size': `${(2 / 12) * 100}%`,
    },
  },

  extraFoodChangerSecondGridCol: {
    WebkitFlexBasis: `${(8 / 12) * 100}%`,
    flexBasis: `${(8 / 12) * 100}%`,
    maxWidth: `${(8 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(8 / 12) * 100}%`,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    lineHeight: 1,

    [theme.fn.smallerThan('sm')]: {
      padding: 4,
      margin: 0,
      WebkitFlexBasis: `${(8 / 12) * 100}%`,
      flexBasis: `${(8 / 12) * 100}%`,
      maxWidth: `${(8 / 12) * 100}%`,
      ':-ms-flex-preferred-size': `${(8 / 12) * 100}%`,
    },
  },

  extraFoodChangerThirdGridCol: {
    WebkitFlexBasis: `${(2 / 12) * 100}%`,
    flexBasis: `${(2 / 12) * 100}%`,
    maxWidth: `${(2 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(2 / 12) * 100}%`,

    [theme.fn.smallerThan('sm')]: {
      padding: 0,
      margin: 0,
      WebkitFlexBasis: `${(2 / 12) * 100}%`,
      flexBasis: `${(2 / 12) * 100}%`,
      maxWidth: `${(2 / 12) * 100}%`,
      ':-ms-flex-preferred-size': `${(2 / 12) * 100}%`,
    },
  },

  foodQuantityChangerGrid: {
    width: '16%',
    padding: 0,
    margin: 0,

    [theme.fn.smallerThan(600)]: {
      width: '36%',
      padding: 0,
      margin: 0,
    },
  },

  foodQuantityChangerGenericGridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexShrink: 0,
    flexShrink: 0,
    WebkitFlexGrow: 0,
    flexGrow: 0,
    ':-ms-flex-negative': 0,
    ':-ms-flex-positive': 0,
    ':-webkit-box-flex': 0,
  },

  foodQuantityChangerFirstGridCol: {
    padding: 0,
    margin: 0,
    WebkitFlexBasis: `${(4 / 12) * 100}%`,
    flexBasis: `${(4 / 12) * 100}%`,
    maxWidth: `${(4 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(4 / 12) * 100}%`,

    // [theme.fn.smallerThan('sm')]: {
    //   padding: 0,
    //   margin: 0,
    //   WebkitFlexBasis: `${(3 / 12) * 100}%`,
    //   flexBasis: `${(3 / 12) * 100}%`,
    //   maxWidth: `${(3 / 12) * 100}%`,
    //   ':-ms-flex-preferred-size': `${(3 / 12) * 100}%`,
    // },
  },

  foodQuantityChangerSecondGridCol: {
    WebkitFlexBasis: `${(4 / 12) * 100}%`,
    flexBasis: `${(4 / 12) * 100}%`,
    maxWidth: `${(4 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(4 / 12) * 100}%`,

    // [theme.fn.smallerThan('sm')]: {
    //   padding: 4,
    //   margin: 0,
    //   WebkitFlexBasis: `${(6 / 12) * 100}%`,
    //   flexBasis: `${(6 / 12) * 100}%`,
    //   maxWidth: `${(6 / 12) * 100}%`,
    //   ':-ms-flex-preferred-size': `${(6 / 12) * 100}%`,
    // },
  },

  foodQuantityChangerThirdGridCol: {
    WebkitFlexBasis: `${(4 / 12) * 100}%`,
    flexBasis: `${(4 / 12) * 100}%`,
    maxWidth: `${(4 / 12) * 100}%`,
    ':-ms-flex-preferred-size': `${(4 / 12) * 100}%`,

    // [theme.fn.smallerThan('sm')]: {
    //   padding: 0,
    //   margin: 0,
    //   WebkitFlexBasis: `${(3 / 12) * 100}%`,
    //   flexBasis: `${(3 / 12) * 100}%`,
    //   maxWidth: `${(3 / 12) * 100}%`,
    //   ':-ms-flex-preferred-size': `${(3 / 12) * 100}%`,
    // },
  },
}));
